import React from "react";
import { useNavigate, useLocation } from "react-router";
import PrivacyDisclaimer from "./PrivacyDisclaimer";

export default function Privacy() {
	// History
	const navigate = useNavigate();
	const location = useLocation();
	// Handlers
	function handleClick() {
		if (location !== "/") {
			navigate("/");
		}
	}
	// Render
	return (
		<div className="login">
			<div>
				<div id="logo-conti-top">
					<span></span>
				</div>
			</div>
			<div id="main-menu" className="home">
				<div id="logo-conti-top-mobile">
					<span></span>
				</div>
			</div>
			<div id="login-content">
				<article className="terms">
					<div className="right">
						<div onClick={handleClick} className="button main">
							{"<"} Regresar
						</div>
					</div>
					<PrivacyDisclaimer />
					<div className="center">
						<div onClick={handleClick} className="button main">
							{"<"} Regresar
						</div>
					</div>
				</article>
			</div>
			<div id="outer-frame">
				<div id="main-container"></div>
			</div>
		</div>
	);
}
